<template>
	<div class="stats-overview">
		<div class="stats-cards">
			<div class="stats-card">
				<div class="card-icon card-icon-publish">
					<i class="el-icon-plus"></i>
				</div>
				<div class="card-content">
					<div class="card-value">{{ statsData.total_publish || 0 }}</div>
					<div class="card-label">发布数量</div>
				</div>
			</div>
			<div class="stats-card">
				<div class="card-icon card-icon-pulloff">
					<i class="el-icon-bottom"></i>
				</div>
				<div class="card-content">
					<div class="card-value">{{ statsData.total_pulloff || 0 }}</div>
					<div class="card-label">下架数量</div>
				</div>
			</div>
			<div class="stats-card">
				<div class="card-icon card-icon-delete">
					<i class="el-icon-delete"></i>
				</div>
				<div class="card-content">
					<div class="card-value">{{ statsData.total_delete || 0 }}</div>
					<div class="card-label">删除数量</div>
				</div>
			</div>
			<div class="stats-card">
				<div class="card-icon card-icon-total">
					<i class="el-icon-data-line"></i>
				</div>
				<div class="card-content">
					<div class="card-value">{{ totalCount }}</div>
					<div class="card-label">总计</div>
				</div>
			</div>
		</div>
		
		<div class="reason-section">
			<div class="reason-card">
				<div class="reason-header">
					<span class="reason-title">下架原因统计</span>
				</div>
				<div class="reason-content">
					<div v-if="!hasPulloffReasons" class="empty-data">暂无下架数据</div>
					<div v-else class="reason-list">
						<div v-for="(count, reason) in statsData.pulloff_reasons" :key="'pulloff-' + reason" class="reason-item">
							<div class="reason-info">
								<span class="reason-name">{{ reason }}</span>
								<span class="reason-percent">{{ getPercent(count, statsData.total_pulloff) }}</span>
							</div>
							<div class="reason-bar">
								<div class="reason-bar-inner pulloff-bar" :style="{ width: getPercent(count, statsData.total_pulloff) }"></div>
							</div>
							<div class="reason-count">{{ count }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="reason-card">
				<div class="reason-header">
					<span class="reason-title">删除原因统计</span>
				</div>
				<div class="reason-content">
					<div v-if="!hasDeleteReasons" class="empty-data">暂无删除数据</div>
					<div v-else class="reason-list">
						<div v-for="(count, reason) in statsData.delete_reasons" :key="'delete-' + reason" class="reason-item">
							<div class="reason-info">
								<span class="reason-name">{{ reason }}</span>
								<span class="reason-percent">{{ getPercent(count, statsData.total_delete) }}</span>
							</div>
							<div class="reason-bar">
								<div class="reason-bar-inner delete-bar" :style="{ width: getPercent(count, statsData.total_delete) }"></div>
							</div>
							<div class="reason-count">{{ count }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatsOverview',
	props: {
		statsData: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		totalCount() {
			return (this.statsData.total_publish || 0) + (this.statsData.total_pulloff || 0) + (this.statsData.total_delete || 0);
		},
		hasPulloffReasons() {
			return this.statsData.pulloff_reasons && Object.keys(this.statsData.pulloff_reasons).length > 0;
		},
		hasDeleteReasons() {
			return this.statsData.delete_reasons && Object.keys(this.statsData.delete_reasons).length > 0;
		}
	},
	methods: {
		getPercent(count, total) {
			if (!total || total === 0) return '0%';
			return Math.round((count / total) * 100) + '%';
		}
	}
};
</script>

<style scoped>
.stats-overview {
	padding: 20px;
}

.stats-cards {
	display: flex;
	gap: 20px;
	margin-bottom: 24px;
}

.stats-card {
	flex: 1;
	background: #fff;
	border-radius: 8px;
	padding: 20px;
	display: flex;
	align-items: center;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	transition: transform 0.3s, box-shadow 0.3s;
}

.stats-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.card-icon {
	width: 56px;
	height: 56px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 16px;
}

.card-icon i {
	font-size: 24px;
	color: #fff;
}

.card-icon-publish {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.card-icon-pulloff {
	background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.card-icon-delete {
	background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.card-icon-total {
	background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.card-content {
	flex: 1;
}

.card-value {
	font-size: 28px;
	font-weight: 600;
	color: #1a1a1a;
	line-height: 1.2;
}

.card-label {
	font-size: 14px;
	color: #999;
	margin-top: 4px;
}

.reason-section {
	display: flex;
	gap: 20px;
}

.reason-card {
	flex: 1;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	overflow: hidden;
}

.reason-header {
	padding: 16px 20px;
	border-bottom: 1px solid #f0f0f0;
	background: #fafafa;
}

.reason-title {
	font-size: 16px;
	font-weight: 600;
	color: #333;
}

.reason-content {
	padding: 20px;
}

.empty-data {
	text-align: center;
	color: #999;
	padding: 40px 0;
	font-size: 14px;
}

.reason-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.reason-item {
	display: flex;
	align-items: center;
	gap: 12px;
}

.reason-info {
	width: 120px;
	display: flex;
	justify-content: space-between;
}

.reason-name {
	font-size: 14px;
	color: #333;
}

.reason-percent {
	font-size: 12px;
	color: #999;
}

.reason-bar {
	flex: 1;
	height: 8px;
	background: #f0f0f0;
	border-radius: 4px;
	overflow: hidden;
}

.reason-bar-inner {
	height: 100%;
	border-radius: 4px;
	transition: width 0.3s ease;
}

.pulloff-bar {
	background: linear-gradient(90deg, #f093fb 0%, #f5576c 100%);
}

.delete-bar {
	background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
}

.reason-count {
	width: 40px;
	text-align: right;
	font-size: 14px;
	font-weight: 600;
	color: #333;
}

@media (max-width: 768px) {
	.stats-cards {
		flex-direction: column;
	}
	
	.reason-section {
		flex-direction: column;
	}
}
</style>
